<template>
  <div class="contents contents--pt _min-h-xlg">
    <notification />
    <list-information />
  </div>
</template>
<script>
import Notification from '../home/components/Notification.vue'
import ListInformation from './components/ListInformation.vue'
export default {
  name: 'Information',
  components: { Notification, ListInformation }
}
</script>
